import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';

const THEMES = {
  light: 'lara-light-teal',
  dark: 'lara-dark-blue',
};

export default function ThemeSwitcher() {
  //const [mode, setMode] = useState('light');

  const stored = localStorage.getItem('theme');
const [mode, setMode] = useState(stored || 'light');

  useEffect(() => {
    let linkTag = document.getElementById('app-theme');

    if (!linkTag) {
      linkTag = document.createElement('link');
      linkTag.id = 'app-theme';
      linkTag.rel = 'stylesheet';
      document.head.appendChild(linkTag);
    }

    linkTag.href = `/themes/${THEMES[mode]}/theme.css`;
    document.body.classList.remove('p-theme-light', 'p-theme-dark');
  document.body.classList.add(mode === 'light' ? 'p-theme-light' : 'p-theme-dark');
  }, [mode]);

  const toggleTheme = () => {
    setMode((prev) => (prev === 'light' ? 'dark' : 'light'));
    localStorage.setItem('theme', mode === 'light' ? 'dark' : 'light');
  };

  return (
    <div className="flex align-items-center gap-2">
      <span className="text-sm">{mode === 'light' ? 'Claro' : 'Oscuro'}</span>
      <Button
        icon={mode === 'light' ? 'pi pi-moon' : 'pi pi-sun'}
        onClick={toggleTheme}
        rounded
        text
        aria-label="Cambiar tema"
        className="p-button-sm"
      />
    </div>
  );
}
